// extracted by mini-css-extract-plugin
module.exports = {"default":"tooltipLink_default__TquVr","disableLink":"tooltipLink_disableLink__2leqH","tooltip":"tooltipLink_tooltip__2DYUB"};